import { cn } from '@lyearn/style';
import { imageBorderStyles } from '@lyearn/ui';
import { Image } from '@/components/Image';

const renderImage = ({
  image,
  className,
  contentName,
  width,
  height,
}: {
  image?: string | null;
  className?: string;
  contentName: string;
  width: number;
  height: number;
}) => {
  if (image) {
    return (
      <Image
        alt={contentName}
        className={cn('flex-shrink-0 rounded-4', imageBorderStyles({ size: '1px' }), className)}
        height={height}
        src={image}
        width={width}
      />
    );
  }

  return null;
};

export default renderImage;
